export const zIndex = {
	behind: '-1',
	base: '0',
	dropdown: '100',
};
